import { WorkRequirementExemptionsScreen } from "@/interactors/WorkRequirementExemptionsScreen";

export default function WorkRequirementExemptions() {
  return <WorkRequirementExemptionsScreen />;
}
